import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Container,
  Stack,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PhoneIcon from "@mui/icons-material/Phone";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/images/company-logo.webp";
import Logo1 from "../assets/images/company-logo.svg";
import Logo2 from "../assets/images/company-logo-desk.svg";
import NewLogo from "../assets/home/logo 1.svg";
import PsnLogo from "../assets/home/psn_logo.png";
import LeapTrucksLogo from "../assets/home/leaptrucks.png";
import { paths } from "../routes/path";
import TwoWheeler from "../assets/images/two-wheeler.webp";
import car from "../assets/images/car-header.webp";
import commercial from "../assets/images/commercial-header.webp";
import Construction from "../assets/images/commercial_equp.webp";
import contructionHousing from "../assets/images/construction-house.webp";
import contructionpurchase from "../assets/images/construction-purche.webp";
import insurance from "../assets/images/insurence-amc.webp";
import spare from "../assets/images/parts.webp";
import otherLoan from "../assets/images/other-loan.webp";

export default function Header() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [openSubSubMenu, setOpenSubSubMenu] = useState(null);

  // SEO-friendly NavLink component
  const NavLink = ({ text, menuItems, path, children, color = "white" }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [hovered, setHovered] = useState(false);
    const [open, setOpen] = useState(false);
    const [hoveredSub, setHoveredSub] = useState(null);
    let closeTimer = null;
    const { pathname } = useLocation();

    const handleMouseEnter = (event) => {
      setHovered(true);
      clearTimeout(closeTimer);
      setAnchorEl(event.currentTarget);
      setOpen(true);
    };

    const handleClick = (event) => {
      if (menuItems) {
        event.preventDefault();
        setHovered(true);
        clearTimeout(closeTimer);
        setAnchorEl(event.currentTarget);
        setOpen(prev => !prev);
      }
    };

    const handleClose = () => {
      setHovered(false);
      closeTimer = setTimeout(() => {
        setOpen(false);
      }, 200);
    };

    const handleMenuEnter = () => {
      clearTimeout(closeTimer);
    };

    const handleMenuItemClick = (path) => {
      setOpen(false);
      navigate(path);
    };

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return (
      <Box sx={{ position: "relative" }}>
        {/* Use React Router Link for proper client-side navigation */}
        <Link
          to={path}
          style={{
            textDecoration: "none",
            color: color,
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 500,
            padding: "0px 10px",
            display: "inline-flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            fontFamily: theme.typography.fontFamily,
          }}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleClose}
        >
          {text}
          {menuItems && (
            <KeyboardArrowDownIcon
              sx={{
                transition: "transform 0.3s ease",
                transform: hovered ? "rotate(180deg)" : "rotate(0deg)",
                marginLeft: "4px",
              }}
            />
          )}
        </Link>

        {menuItems && (
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setOpen(false)}
            onMouseEnter={handleMenuEnter}
            onMouseLeave={handleClose}
            sx={{
              pointerEvents: "none",
              "& .MuiPaper-root": {
                position: "relative",
                pointerEvents: "auto",
                width: "230px",
                borderRadius: "0px",
                borderTop: "4px solid #00cc87",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                background: "linear-gradient(180deg,#f0f2f6 0,#fff 100%)",
                overflow: "visible",
              },
            }}
          >
            <Box elevation={0}>
              {menuItems.map((item, index) => {
                if (item.subItems) {
                  return (
                    <Box 
                      key={index}
                      onMouseEnter={() => setHoveredSub(index)}
                      onMouseLeave={() => setHoveredSub(null)}
                      sx={{ position: "relative" }}
                    >
                      <MenuItem
                        sx={{
                          fontSize: "14px",
                          display: "flex",
                          justifyContent: "space-between",
                          "&:hover": {
                            backgroundColor: "#ddd",
                            cursor: "pointer",
                          },
                        }}
                      >
                        {item.label}
                        <KeyboardArrowRightIcon sx={{ fontSize: '1.2rem', color: "#555" }} />
                      </MenuItem>
                      {hoveredSub === index && (
                        <Box sx={{
                          position: "absolute",
                          left: "100%",
                          top: "-4px", // Align with borderTop
                          width: "230px",
                          background: "linear-gradient(180deg,#f0f2f6 0,#fff 100%)",
                          boxShadow: "4px 4px 8px rgba(0,0,0,0.1)",
                          borderTop: "4px solid #00cc87",
                          zIndex: 2,
                        }}>
                          {item.subItems.map((sub, i) => (
                            <Link to={sub.path} key={i} style={{ textDecoration: "none", color: "black" }}>
                              <MenuItem onClick={() => setOpen(false)} sx={{ fontSize: "14px", "&:hover": { backgroundColor: "#ddd" } }}>
                                {sub.label}
                              </MenuItem>
                            </Link>
                          ))}
                        </Box>
                      )}
                    </Box>
                  );
                }

                return (
                  <Link
                    to={item.path}
                    key={index}
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <MenuItem
                      sx={{
                        fontSize: "14px",
                        "&:hover": {
                          backgroundColor: "#ddd",
                          cursor: "pointer",
                        },
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  </Link>
                );
              })}
            </Box>
          </Menu>
        )}
      </Box>
    );
  };

  // Mobile Navigation Menu
  const MobileNavMenu = () => {
    const handleSubMenuToggle = (index) => {
      setOpenSubMenu(openSubMenu === index ? null : index);
    };

    const loanMenuItems = [
      {
        label: "Used Commercial Vehicle Loan",
        path: paths.dashboard.commercialVehicleLoan,
      },
      {
        label: "Used Car Loan",
        path: paths.dashboard.carloan,
      },
      {
        label: "Used Tractor Loan",
        path: paths.dashboard.usedTractorFinance,
      },
      {
        label: "Green Loans",
        subItems: [
          { label: "EV Car Loan", path: paths.dashboard.evCarLoan },
          { label: "EV Truck Loan", path: paths.dashboard.evTruckLoan },
          { label: "EV 3 Wheeler Loan", path: paths.dashboard.ev3WheelerLoan },
        ],
      },
      {
        label: "Business Loan",
        path: paths.dashboard.usedBusinessLoan,
      },
    ];

    const menuItems = [
      { label: "Home", path: paths.dashboard.root },
      { label: "Products", subItems: loanMenuItems },
      { label: "About Us", path: paths.dashboard.aboutUs },
      { label: "Careers", path: paths.dashboard.careers },

      { label: "EMI Calculator", path: paths.dashboard.emiCalculator },
      { label: "Contact Us", path: paths.dashboard.contactUs },
    ];

    return (
      <Drawer
        anchor="left"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "280px",
            backgroundColor: "#f8f9fa",
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Link to={paths.dashboard.root}>
            <img src={Logo2} alt="Company Logo" style={{ height: "40px" }} />
          </Link>
          <IconButton onClick={() => setMobileMenuOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ pt: 0 }}>
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              <ListItem
                button
                onClick={() => {
                  if (item.subItems) {
                    handleSubMenuToggle(index);
                  } else if (item.path) {
                    navigate(item.path);
                    setMobileMenuOpen(false);
                  }
                }}
                sx={{
                  borderBottom: "1px solid #e0e0e0",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#333",
                    },
                  }}
                />
                {item.subItems &&
                  (openSubMenu === index ? <ExpandLess /> : <ExpandMore />)}
              </ListItem>

              {item.subItems && (
                <Collapse
                  in={openSubMenu === index}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.subItems.map((subItem, subIndex) => (
                      <React.Fragment key={subIndex}>
                        <ListItem
                          button
                          sx={{
                            pl: 4,
                            backgroundColor: "#f0f0f0",
                            "&:hover": {
                              backgroundColor: "#e0e0e0",
                            },
                          }}
                          onClick={() => {
                            if (subItem.subItems) {
                              setOpenSubSubMenu(openSubSubMenu === subIndex ? null : subIndex);
                            } else {
                              navigate(subItem.path);
                              setMobileMenuOpen(false);
                            }
                          }}
                        >
                          <ListItemText
                            primary={subItem.label}
                            sx={{
                              "& .MuiListItemText-primary": {
                                fontSize: "14px",
                                color: "#555",
                              },
                            }}
                          />
                          {subItem.subItems &&
                            (openSubSubMenu === subIndex ? <ExpandLess /> : <ExpandMore />)}
                        </ListItem>

                        {subItem.subItems && (
                          <Collapse in={openSubSubMenu === subIndex} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {subItem.subItems.map((subSubItem, subSubIndex) => (
                                <ListItem
                                  key={subSubIndex}
                                  button
                                  sx={{ pl: 6, backgroundColor: "#e8e8e8", "&:hover": { backgroundColor: "#ddd" } }}
                                  onClick={() => {
                                    navigate(subSubItem.path);
                                    setMobileMenuOpen(false);
                                  }}
                                >
                                  <ListItemText
                                    primary={subSubItem.label}
                                    sx={{ "& .MuiListItemText-primary": { fontSize: "13px", color: "#666" } }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>

        <Box sx={{ p: 2, mt: "auto", borderTop: "1px solid #e0e0e0" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <PhoneIcon sx={{ color: "#0072ff", fontSize: 20 }} />
            <a
              href="tel:6364903820"
              id="callUs-Button-header"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#0072ff",
                  fontWeight: 500,
                  fontSize: "16px",
                }}
              >
                +91 6364903820
              </Typography>
            </a>
          </Box>

          <Link
            to={paths.dashboard.contactUs}
            id="applyLoan-Button-header"
            style={{ textDecoration: "none" }}
          >
            <Box
              sx={{
                backgroundColor: "#00cc87",
                color: "white",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "14px",
                padding: "12px",
                borderRadius: "24px",
                textAlign: "center",
                width: "100%",
                display: "block",
                "&:hover": {
                  backgroundColor: "#0265fe",
                },
              }}
            >
              Apply for Loan
            </Box>
          </Link>
        </Box>
      </Drawer>
    );
  };

  // SEO-friendly Loan Service Box
  const LoanServiceBox = ({ title, subtitle, path, dropdownItems }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    let closeTimer = null;

    const handleMouseEnter = (event) => {
      if (dropdownItems && dropdownItems.length > 0) {
        clearTimeout(closeTimer);
        setAnchorEl(event.currentTarget);
        setOpen(true);
      }
    };

    const handleMouseLeave = () => {
      if (dropdownItems && dropdownItems.length > 0) {
        closeTimer = setTimeout(() => {
          setOpen(false);
        }, 100);
      }
    };

    const handleMenuEnter = () => {
      clearTimeout(closeTimer);
    };

    return (
      <Box sx={{ position: "relative" }}>
        <Link
          to={path}
          style={{ textDecoration: "none" }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "start",
              justifyContent: "center",
              flexDirection: "column",
              p: "5px 10px",
              m: "0px 10px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#f5f5f5",
                borderRadius: "5px",
              },
            }}
          >
            <Typography
              sx={{
                color: "#000",
                fontSize: "14px",
                fontWeight: 500,
                textAlign: "center",
                fontFamily: "Inter, sans-serif",
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#606060",
                fontSize: "11px",
                fontWeight: 300,
                textAlign: "center",
                fontFamily: "Inter, sans-serif",
              }}
            >
              {subtitle}
            </Typography>
          </Box>
        </Link>

        {dropdownItems && dropdownItems.length > 0 && (
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setOpen(false)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            sx={{
              pointerEvents: "none",
              "& .MuiPaper-root": {
                pointerEvents: "auto",
                minWidth: "20%",
                maxWidth: "20%",
                borderRadius: "0px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                background: "#ffffff",
                borderTop: "4px solid #0265fe",
                mt: 0.5,
                overflow: "visible",
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: "-8px",
                  left: "50%",
                  transform: "translateX(50%)",
                  width: "0",
                  height: "0",
                  borderLeft: "8px solid transparent",
                  borderRight: "8px solid transparent",
                  borderBottom: "6px solid #0265fe",
                },
              },
            }}
          >
            <Box
              onMouseEnter={handleMenuEnter}
              onMouseLeave={handleMouseLeave}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 0,
                p: 1,
              }}
            >
              {dropdownItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <MenuItem
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      py: 1,
                      px: 1,
                      borderRadius: "0px",
                      border: "none",
                      "&:hover": {
                        backgroundColor: "#f8f9fa",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={item.icon}
                      alt={item.label}
                      sx={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 600,
                          color: "#333",
                          lineHeight: 1.2,
                        }}
                      >
                        {item.label}
                      </Typography>
                      {item.description && (
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "#666",
                            fontWeight: 400,
                            lineHeight: 1.3,
                          }}
                        >
                          {item.description}
                        </Typography>
                      )}
                    </Box>
                  </MenuItem>
                </Link>
              ))}
            </Box>
          </Menu>
        )}
      </Box>
    );
  };

  // Define dropdown items for each loan service
  const loanServices = [
    {
      title: "Vehicle",
      subtitle: "New & Used Vehicles",
      dropdownItems: [
        {
          label: "Commercial Vehicle",
          description: "Loans",
          path: paths.dashboard.commercialVehicleLoan,
          icon: commercial,
        },
        {
          label: "Construction Equipment",
          description: "Loans",
          path: paths.dashboard.constructorEquipment,
          icon: Construction,
        },
        {
          label: "Two Wheeler",
          description: "Loans",
          path: paths.dashboard.twoWheelerpage,
          icon: TwoWheeler,
        },
        {
          label: "Car Loan",
          description: "Loans",
          path: paths.dashboard.carloan,
          icon: car,
        },
      ],
    },
    {
      title: "Housing Loan",
      subtitle: "Purchase & Construction",
      dropdownItems: [
        {
          label: "House Construction",
          description: "Loans",
          path: paths.dashboard.houseConstruction,
          icon: contructionHousing,
        },
        {
          label: "House Purchase",
          description: "Loans",
          path: paths.dashboard.housePurchase,
          icon: contructionpurchase,
        },
      ],
    },
    {
      title: "Loan Against Property",
      subtitle: "Secured Long Term Loans",
      path: paths.dashboard.loanAgainestProperty,
    },
    {
      title: "Business Loans",
      subtitle: "Business Expansion",
      dropdownItems: [
        {
          label: "Insurance & AMC",
          path: paths.dashboard.insurenceAMC,
          icon: insurance,
        },
        {
          label: "Spare Parts",
          path: paths.dashboard.spareParts,
          icon: spare,
        },
        {
          label: "Other Business Loans",
          path: paths.dashboard.otherBusinessLoan,
          icon: otherLoan,
        },
        {
          label: "Business Loan",
          path: paths.dashboard.usedBusinessLoan,
          icon: otherLoan,
        },
        {
          label: "Used Tractor Loan",
          path: paths.dashboard.usedTractorFinance,
          icon: otherLoan,
        },
      ],
    },
    {
      title: "Personal Loan",
      subtitle: "Consumer & Small Enterprises",
      path: paths.dashboard.personalLoan,
    },
  ];

  return (
    <Box sx={{ position: "sticky", top: 0, zIndex: 100 }}>
      <AppBar position="static" elevation={0} sx={{ display: { xs: "block", md: "none" } }}>
        <Box
          sx={{
            background: {
              xs: "#fff",
              md: "linear-gradient(to right, #3d94ff, #335cb3, #335cb3, #3d94ff)",
            },
            boxShadow: {
              xs: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;",
              md: "none",
            },
          }}
        >
          <Container maxWidth="lg">
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: { xs: "space-between", md: "center" },
                gap: 5,
                py: 0,
                minHeight: { xs: "56px", md: "35px" },
              }}
            >
              {/* Mobile Logo */}
              {isMobile && (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Link
                    to={paths.dashboard.root}
                    style={{ textDecoration: "none" }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mt: 1 }}>
                      <img
                        src={PsnLogo}
                        alt="Company Logo"
                        style={{
                          height: "45px",
                          width: "140px",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Link>
                </Box>
              )}

              {/* Navigation Menu - Hidden on mobile */}
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <NavLink text="Home" path={paths.dashboard.root} />
                <NavLink
                  text="Products"
                  menuItems={[
                    {
                      label: "Used Commercial Vehicle Loan",
                      path: paths.dashboard.commercialVehicleLoan,
                    },
                    {
                      label: "Used Car Loan",
                      path: paths.dashboard.carloan,
                    },
                    {
                      label: "Used Tractor Loan",
                      path: paths.dashboard.usedTractorFinance,
                    },
                    {
                      label: "Green Loans",
                      subItems: [
                        { label: "EV Car Loan", path: paths.dashboard.evCarLoan },
                        { label: "EV Truck Loan", path: paths.dashboard.evTruckLoan },
                        { label: "EV 3 Wheeler Loan", path: paths.dashboard.ev3WheelerLoan },
                      ]
                    },
                    {
                      label: "Business Loan",
                      path: paths.dashboard.usedBusinessLoan,
                    },
                  ]}
                />
                <NavLink text="About Us" path={paths.dashboard.aboutUs} />

                <NavLink text="Careers" path={paths.dashboard.careers} />
                <NavLink
                  text="EMI Calculator"
                  path={paths.dashboard.emiCalculator}
                />
                <NavLink text="Contact Us" path={paths.dashboard.contactUs} />
              </Box>

              {/* Right side content */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1, md: 2 },
                }}
              >
                {/* Mobile Menu Button */}
                {isMobile ? (
                  <IconButton
                    onClick={() => setMobileMenuOpen(true)}
                    sx={{ p: 1, mt: 0.5, color: "#0265fe" }}
                  >
                    <MenuIcon />
                  </IconButton>
                ) : (
                  <>
                    {/* Phone number - Desktop only */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <PhoneIcon sx={{ color: "white", fontSize: 20 }} />
                      <a
                        href="tel:6364903820"
                        id="callUs-Button-header"
                        style={{ textDecoration: "none", cursor: "pointer" }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: "white",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          +91 63649 03820
                        </Typography>
                      </a>
                    </Box>

                    <Link
                      to={paths.dashboard.contactUs}
                      id="applyLoan-Button-header"
                      style={{ textDecoration: "none" }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#00cc87",
                          color: "white",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "15px",
                          padding: "1px 15px",
                          borderRadius: "24px",
                          display: "inline-block",
                          "&:hover": {
                            backgroundColor: "#0265fe",
                          },
                        }}
                      >
                        Apply for Loan
                      </Box>
                    </Link>
                  </>
                )}
              </Box>
            </Toolbar>
          </Container>
        </Box>
      </AppBar>

      {/* Mobile Navigation Drawer */}
      <MobileNavMenu />

      {/* NEW Unified Desktop Header */}
      <Box
        sx={{
          backgroundColor: "#fff",
          pt: 1.5,
          pb: 1.5,
          display: { xs: "none", md: "block" },
          boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          position: "sticky",
          top: 0,
          zIndex: 1100,
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{ width: "100%" }}
          >
            <Link to={paths.dashboard.root} style={{ textDecoration: "none" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img
                  src={PsnLogo}
                  alt="Company Logo"
                  style={{ height: "60px", width: "180px", objectFit: "contain" }}
                />
              </Box>
            </Link>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                
                <NavLink color="#000" text="Products" menuItems={[
                    { label: "Used Commercial Vehicle Loans", path: paths.dashboard.commercialVehicleLoan },
                    { label: "Used Car Loans", path: paths.dashboard.carloan },
                    { label: "Used Tractor Loans", path: paths.dashboard.usedTractorFinance },
                    { label: "Green Loans", subItems: [
                        { label: "EV Car Loan", path: paths.dashboard.evCarLoan },
                        { label: "EV Truck Loan", path: paths.dashboard.evTruckLoan },
                        { label: "EV 3 Wheeler Loan", path: paths.dashboard.ev3WheelerLoan },
                    ]},
                    { label: "Business Loans", path: paths.dashboard.usedBusinessLoan },
                ]} />
                <Box sx={{ width: "1px", height: "20px", backgroundColor: "#ccc", mx: 1 }} />
                
                <NavLink color="#000" text="About Us" path={paths.dashboard.aboutUs} />
                <Box sx={{ width: "1px", height: "20px", backgroundColor: "#ccc", mx: 1 }} />
                
                <NavLink color="#000" text="Career" path={paths.dashboard.careers} />
                <Box sx={{ width: "1px", height: "20px", backgroundColor: "#ccc", mx: 1 }} />
                
                <NavLink color="#000" text="EMI Calculator" path={paths.dashboard.emiCalculator} />
                <Box sx={{ width: "1px", height: "20px", backgroundColor: "#ccc", mx: 1 }} />
                
                <NavLink color="#000" text="Contact Us" path={paths.dashboard.contactUs} />
                <Box sx={{ width: "1px", height: "20px", backgroundColor: "#ccc", mx: 1 }} />
                
                <a href="https://www.leaptrucks.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <img src={LeapTrucksLogo} alt="LeapTrucks" style={{ height: "30px", objectFit: "contain" }} />
                  </Box>
                </a>
                <Box sx={{ width: "1px", height: "20px", backgroundColor: "#ccc", mx: 1 }} />
                
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                   <PhoneIcon sx={{ color: "#003b87", fontSize: 20 }} />
                   <Typography variant="body2" sx={{ color: "#000", fontWeight: 600, whiteSpace: "nowrap", fontSize: "16px" }}>+91 63649 03820</Typography>
                </Box>
                
                <Link to={paths.dashboard.contactUs} style={{ textDecoration: "none", marginLeft: "15px", whiteSpace: "nowrap" }}>
                   <Box sx={{ backgroundColor: "#003b87", color: "white", padding: "8px 20px", borderRadius: "24px", fontWeight: 600, fontSize: "14px", whiteSpace: "nowrap" }}>
                     Apply for Loan
                   </Box>
                </Link>
            </Box>
          </Stack>
        </Container>
      </Box>

      {/* Old Loan Services Section with Dropdowns - Hidden as requested */}
      <Box
        sx={{
          backgroundColor: "#fff",
          pt: 2,
          pb: 1,

          display: "none", // Hidden from UI
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction="row"
            // justifyContent="center"
            spacing={1}
            alignItems="center"
            sx={{
              width: "100%",
            }}
          >
            <Link to={paths.dashboard.root}>
              <img
                src={Logo2}
                alt="Company Logo"
                width={"170px"}
                height={"60px"}
                style={{ marginRight: "10px" }}
              />
            </Link>

            {loanServices.map((service, index) => (
              <React.Fragment key={service.title}>
                <Box
                  sx={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    borderRadius: "2px",
                    height: "30px",
                  }}
                />
                <LoanServiceBox
                  title={service.title}
                  subtitle={service.subtitle}
                  dropdownItems={service.dropdownItems}
                  path={
                    service.path ||
                    (service.dropdownItems && service.dropdownItems[0]?.path) ||
                    "#"
                  }
                />
                {/* {index < loanServices.length - 1 && (
                  <Box
                    sx={{
                      width: "2px",
                      backgroundColor: "#ccc",
                      borderRadius: "2px",
                      height: "30px",
                    }}
                  />
                )} */}
              </React.Fragment>
            ))}
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
